import { Popover } from "@material-ui/core";
import { ICardElementWithChildren } from "backend/model/model";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
import PopoverContent from "./PopoverContent";
import useTopElements from "backend/hooks/model/useTopElements";

const useStyles = makeThemedStyles("DepartmentPopover", (theme: any) => ({  
  paper: {
    fontSize: "1.142em",
    padding: 0,
    borderRadius: "1.6em",
    width: "29.3em",
    overflowX: "unset",
    overflowY: "unset",
    boxShadow: "0px 3px 6px rgba(0,0,0,0.2)",
  }
}));

const DepartmentPopover = (
  props: React.PropsWithChildren<{
    items: ICardElementWithChildren[];
    typenames: string[];
    isOpen?: boolean;
    anchor?: HTMLButtonElement | HTMLDivElement | null;
    onClose?: () => void;
    onSelect?: () => void;
    onSelectChild?: (item: ICardElementWithChildren) => void;
    rtl?: boolean;
    departmentIcon?: string;
  }>
) => {
  const classes = useStyles();
  const ref = React.useRef<HTMLElement | null>(null);
  const { data: topElems, isLoading: topElementsLoading } = useTopElements();
  return topElementsLoading ? null : (
    <Popover
      ref={ref}
      open={!!props.isOpen}
      anchorEl={props.anchor}
      onClose={props.onClose}
      classes={{ paper: classes.paper }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: props.rtl ? "left" : "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: props.rtl ? "right" : "left",
      }}
      dir={props.rtl ? "rtl" : "ltr"}
    >
      <PopoverContent
        elements={props.items}
        topelements={topElems || []}
        onSelect={props.onSelect}
        imageUrl={props.departmentIcon}
      />
    </Popover>
  );
};

export default DepartmentPopover;
